import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import LoadingIndicator from "../../utils/LoadingIndicator/LoadingIndicator";
import axios from "../../utils/Axios/axiosProxy";
import styles from "../UserEntry/UserEntry.module.scss";

export const ProposalStatusChange = (props) => {
  const { id, response } = props.match.params;
  const [loading, setLoading] = React.useState(true);
  const [message, setMessage] = React.useState("");
  const [proposalAnswered, setProposalAnswered] = React.useState(false);

  useEffect(() => {
    const getOrderFromDB = (orderID) => {
      let data = { orderID: orderID };
      axios
        .post("/api/order/id", JSON.stringify(data), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          console.log("GET ORDER RESPONSE: ", res.statusText);
          setLoading(false);
          if (res.data.order.proposalstatus === "open") {
            let data = {
              orderID: id,
              proposal: true,
              updateParams: {
                proposalstatus: response,
              },
            };
            axios
              .patch(`/api/order/update`, data)
              .then((res) => {
                console.log("CONFIRMATION RESPONSE: ", res.data.statusText);
              })
              .catch((error) => {
                console.log("CONFIRMATION ERROR: ", error.res.data.message);
              });
          } else {
            if (res.data.order.proposalstatus === "accepted") {
              setMessage("This proposal has already been accepted.");
            } else if (res.data.order.proposalstatus === "declined") {
              setMessage("This proposal has already been declined.");
            } else {
              setMessage("This proposal is being processed.");
            }
            setProposalAnswered(true);
          }
        })
        .catch((error) => {
          console.log("GET ORDER ERROR: ", error.response.data);
        })
        .catch((error) => console.log("GET ORDER CLIENT ERROR:", error));
    };
    getOrderFromDB(id);
  }, [id, response]);

  return (
    <div className={styles.UserEntryContainer}>
      <div className={styles.UserEntryContent}>
        <h2 className={styles.UserEntryTitle}>Proposal Status</h2>
        {loading ? (
          <LoadingIndicator />
        ) : (
          <>
            {proposalAnswered ? (
              <div className={`${styles.UserEntryInputs} FlexCenter Column`}>
                <div>
                  <h2 className={styles.ConformationMessage}>{message}</h2>
                </div>
              </div>
            ) : (
              <div className={`${styles.UserEntryInputs} FlexCenter Column`}>
                <div>
                  {response === "accepted" ? (
                    <h2 className={styles.ConformationMessage}>
                      Proposal accepted! <br />
                      Thank you for accepting our proposal.
                    </h2>
                  ) : (
                    <h2 className={styles.ConformationMessage}>
                      Proposal decined! <br />
                      We are sorry to see that you declined our proposal.
                    </h2>
                  )}
                </div>
                {response === "accepted" ? (
                  <div className={styles.UserEntryButton}>
                    <Link to={`/track/${id}`}>
                      <Button className="ToreaBay Medium MarginHorizontal">
                        Track Order
                      </Button>
                    </Link>
                  </div>
                ) : null}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
